class ProductMedia extends HTMLElement {
  connectedCallback() {
    this.slides = Array.from(this.querySelectorAll('.product-media__slide'));
    this.thumbs = Array.from(this.querySelectorAll('[data-thumb]'));
    this.modal = this.querySelector('[data-zoom-modal]');
    this.modalImages = this.modal ? Array.from(this.modal.querySelectorAll('[data-zoom-image]')) : [];
    this._releaseFocus = null;

    this.addEventListener('click', (e) => {
      const thumb = e.target.closest('[data-thumb]');
      if (thumb) {
        this.showMedia(thumb.dataset.mediaId);
        return;
      }
      const zoomOpen = e.target.closest('[data-zoom-open]');
      if (zoomOpen) {
        this.openZoom(zoomOpen.dataset.mediaId, zoomOpen);
        return;
      }
      if (e.target.closest('[data-zoom-close]')) {
        this.closeZoom();
      }
    });

    this._onKeydown = (e) => {
      if (e.key === 'Escape') this.closeZoom();
    };
  }

  showMedia(mediaId) {
    this.slides.forEach((slide) => {
      slide.hidden = slide.dataset.mediaId !== mediaId;
    });
    this.thumbs.forEach((thumb) => {
      const active = thumb.dataset.mediaId === mediaId;
      thumb.classList.toggle('is-active', active);
      thumb.setAttribute('aria-selected', String(active));
    });
  }

  openZoom(mediaId, trigger) {
    if (!this.modal) return;
    this.modalImages.forEach((img) => {
      img.hidden = img.dataset.mediaId !== mediaId;
    });
    this.modal.hidden = false;
    document.body.style.overflow = 'hidden';
    document.addEventListener('keydown', this._onKeydown);
    this._trigger = trigger;
    this._releaseFocus = window.ShirtWerk.trapFocus(this.modal.querySelector('.product-media__modal-panel'), this.modal.querySelector('[data-zoom-close]'));
  }

  closeZoom() {
    if (!this.modal || this.modal.hidden) return;
    this.modal.hidden = true;
    document.body.style.overflow = '';
    document.removeEventListener('keydown', this._onKeydown);
    if (this._releaseFocus) this._releaseFocus();
    if (this._trigger) this._trigger.focus();
  }
}
customElements.define('product-media', ProductMedia);
